import { createTheme } from "@mui/material";
import { useMemo } from "react";
import { ToastContainer } from "react-toastify";
import getDesignTokens from "assets/theme";
import { useSelector } from "react-redux";
import { THEME_TYPES } from "constants/theme";
import { useSoftUIController } from "context";
import themeRTL from "assets/theme/theme-rtl";

export const ToastNotification = () => {
  const { themeMode } = useSelector((store) => store?.portal?.settings);
  const theme = useMemo(() => createTheme(getDesignTokens(themeMode)), [themeMode]);
  const [controller] = useSoftUIController();

  const themeToUse = controller?.direction === "rtl" ? themeRTL : theme;
  const isLight = (themeToUse?.palette?.mode || THEME_TYPES.LIGHT) === THEME_TYPES.LIGHT;

  return (
    <ToastContainer
      autoClose={3000}
      pauseOnFocusLoss={false}
      pauseOnHover={false}
      position="top-right"
      theme={isLight ? THEME_TYPES.LIGHT : THEME_TYPES.DARK}
      toastStyle={{
        background: isLight ? undefined : "#000",
        color: isLight ? undefined : "#fff"
      }}
    />
  );
};
